import { axios } from '@/services/axios';

const createCompany = async (formData) => {
    const response = await axios.post('/company', formData);
    return response;
};

export default createCompany;
